import { Box, Stack, Typography } from '@mui/material';
// import { DRAW_REWARDS } from './config';
import prizeIImage from './assets/prize.png';
import prizeIIImage from './assets/prizeII.png';
import prizeIIIImage from './assets/prizeIII.png';
import prizeVoncherImage from './assets/prizeVoucher.png';
import prizeVoncher2Image from './assets/prizeVoucher2.png';
import {
  DrawGroupWrapper,
  DrawItemWrapper,
  DrawWrapper,
  GradientBox,
} from './styled';

import confetti from 'canvas-confetti';

import { moonDrawBet } from '@/apis/casino/draw';
import WrappedButton from '@/components/ui/WrappedButton';
import { isServer } from '@/configs';
import busEvents from '@/helper/busEvents';
import useLoginModal from '@/hooks/biz/useLoginModal';
import {
  currentCurrencyState,
  isLoggedIn,
  walletInfoCurrentSelectedWallet,
} from '@/state/userInfo';
import useTheme from '@/theme/useTheme';
import { formatMoneyByCurrency } from '@/utils';
import playSound from '@/utils/dom/playSound';
import { ArrowDropDown, Bolt, RocketLaunchRounded } from '@mui/icons-material';
import { useIsomorphicLayoutEffect, useRequest } from 'ahooks';
import { HTMLSVGElement } from 'country-flag-icons/react/1x1';
import { useAtomValue } from 'jotai';
import { Trans, useTranslation } from 'next-i18next';
import Image from 'next/image';
import { useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { gameVolumeState } from '../crash/state';
import {
  MOON_DRAW_UPDATE_BALACE_DELAY_MS,
  MOON_DRAW_UPDATE_BALACE_DELAY_MS_SHORT,
} from './config';
import {
  NEAR_MISS_GAP,
  PHASE1_ANIMATION_DURATION,
  PHASE2_ANIMATION_DURATION,
} from './helper';
import MoneyWithCurrencyIcon from '@/components/biz/MoneyWithCurrencyIcon';
import useCurrencyRate from '@/hooks/biz/useCurrencyRateTable';

const DRAW_AMOUNT = 0.52;

const fireConfetti = () => {
  var count = 200;
  var defaults = {
    origin: { y: 0.7 },
    zIndex: 1300,
  };

  function fire(particleRatio, opts) {
    confetti({
      ...defaults,
      ...opts,
      particleCount: Math.floor(count * particleRatio),
    });
  }

  fire(0.25, {
    spread: 26,
    startVelocity: 55,
  });
  fire(0.2, {
    spread: 60,
  });
  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
  });
  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
  });
  fire(0.1, {
    spread: 120,
    startVelocity: 45,
  });
};

const DrawBtn = ({
  wrapperRef,
  drawRewards,
}: {
  wrapperRef: React.RefObject<HTMLDivElement>;
  drawRewards: any[];
}) => {
  const [drawing, setDrawing] = useState(false);
  const [enableNearMiss, setEnableNearMiss] = useState(false);
  const [enableTurboMode, setEnableTurboMode] = useState(false);

  const isLogin = useAtomValue(isLoggedIn);
  const [, showLoginModal] = useLoginModal();
  const [t] = useTranslation();
  const { theme } = useTheme();

  const volume = useAtomValue(gameVolumeState);

  const currentSelectedWallet = useAtomValue(walletInfoCurrentSelectedWallet);

  const { loading, runAsync } = useRequest(
    (amount) => {
      return moonDrawBet(amount, currentCurrency);
    },
    {
      manual: true,
    },
  );

  const clickDraw = async (isTryPlay: boolean) => {
    if (!isLogin && !isTryPlay) {
      showLoginModal();
      return;
    }
    playSound('/audios/rush/bet.mp3', volume);
    busEvents.emit(
      'delayBalanceUpdate',
      enableTurboMode
        ? MOON_DRAW_UPDATE_BALACE_DELAY_MS_SHORT
        : MOON_DRAW_UPDATE_BALACE_DELAY_MS,
    );
    const { data } = await runAsync(isTryPlay ? 0 : undefined);
    !enableTurboMode && playSound('/audios/draw/spin.mp3', volume);
    if (!data.payout) {
      toast.error('draw.error');
      return;
    }
    const index = drawRewards.findIndex(
      (cfg) => cfg.amount === Number(data.payout),
    );
    // const index = DRAW_REWARDS.length - 1;
    if (index === -1) {
      toast.error('draw.error');
      return;
    }
    setDrawing(true);
    const firstChild = wrapperRef.current.children[0] as HTMLDivElement;
    firstChild.style.transition = 'none';
    firstChild.style.marginLeft = `0px`;
    const target = wrapperRef.current.children[3].children[
      index
    ] as HTMLDivElement;
    const { width, left } = target.getBoundingClientRect();
    const { width: wrapperWdith, left: wrapperLeft } =
      wrapperRef.current.getBoundingClientRect();

    /**
     * ranging from 0.2 to 1
     */
    const nearMissOffsetPercent = 0.2 + Math.random() * 0.8;
    const nearMissChance = Math.random();
    const nearMissLeftOrRight = Math.random() >= 0.5;

    const shouldHaveNearMiss =
      (enableNearMiss || nearMissChance > 0.3) && !enableTurboMode;

    const nearMissOffset =
      (shouldHaveNearMiss && !enableTurboMode
        ? nearMissLeftOrRight
          ? (width + NEAR_MISS_GAP) / 2
          : (width + NEAR_MISS_GAP) / -2
        : 0) * nearMissOffsetPercent;

    const usedPhase1Duration =
      PHASE1_ANIMATION_DURATION * (enableTurboMode ? 0.2 : 1);

    const scrollTarget = left - wrapperLeft - wrapperWdith / 2 + width / 2;

    requestAnimationFrame(() => {
      firstChild.style.transition = `margin ${
        usedPhase1Duration / 1000
      }s cubic-bezier(0, 0.85, 0.3, 1)`;
      firstChild.style.marginLeft = `-${scrollTarget + nearMissOffset}px`;
    });

    const phase2AnimationDelay =
      usedPhase1Duration * (nearMissOffset ? 1.05 : 1);

    const phase2Animation2Duration = shouldHaveNearMiss
      ? PHASE2_ANIMATION_DURATION
      : 0;

    setTimeout(() => {
      if (!shouldHaveNearMiss) {
        return;
      }
      // console.log('%c~LOG~', 'color: yellow; font-size: 16px;', 'phease 2!');
      firstChild.style.transition = `margin ${
        PHASE2_ANIMATION_DURATION / 1000
      }s cubic-bezier(1, 0, 1, 1)`;
      firstChild.style.marginLeft = `-${scrollTarget}px`;
    }, phase2AnimationDelay);
    setTimeout(() => {
      setDrawing(false);
      const numberPayout = Number(data.payout);
      if (numberPayout >= 60 && numberPayout <= 199) {
        playSound('/audios/draw/med_prize.mp3', volume);
      } else if (numberPayout >= 499) {
        playSound('/audios/draw/big_prize.mp3', volume);
      } else {
        playSound('/audios/draw/reveal_hit.mp3', volume);
      }
      fireConfetti();
    }, phase2AnimationDelay + phase2Animation2Duration);
  };

  const currentCurrency = useAtomValue(currentCurrencyState);

  const { currencyRateTable, isSuccess } = useCurrencyRate();

  const currentCurrencyRate = DRAW_AMOUNT / currencyRateTable[currentCurrency];

  return (
    <Stack
      justifyContent={'center'}
      direction={['column', 'row']}
      alignItems={'center'}
      position={'relative'}
      mt={3}
      sx={{
        [theme.breakpoints.down('sm')]: {
          position: 'fixed',
          bottom: 'calc(56px + max(12px, env(safe-area-inset-bottom)))',
          zIndex: 100,
          width: '100%',
          left: 0,
          padding: theme.spacing(2),
          background: theme.palette.bg.main,
        },
      }}
      gap={1}
    >
      <Stack
        gap={1}
        direction={'row'}
        flexWrap={'wrap'}
        alignItems={'flex-end'}
        sx={{
          [theme.breakpoints.down('sm')]: {
            width: '100%',
          },
        }}
      >
        <Stack>
          <Typography textAlign={'end'} color={'text.secondary'}>
            {formatMoneyByCurrency(DRAW_AMOUNT, {
              withCurrencySymbol: true,
            })}
          </Typography>
          <WrappedButton
            isLoading={loading}
            disabled={
              drawing ||
              !isLogin ||
              currentSelectedWallet?.availableBalance < DRAW_AMOUNT
            }
            variant="contained"
            color="primary"
            onClick={() => clickDraw(false)}
            sx={{
              [theme.breakpoints.down('sm')]: {
                flexGrow: 1,
              },
            }}
          >
            <Trans
              i18nKey="Open for&nbsp;<amount></amount>"
              ns="moon-draw"
              components={{
                amount: !isNaN(currentCurrencyRate) ? (
                  <MoneyWithCurrencyIcon
                    value={currentCurrencyRate}
                    currency={currentCurrency}
                  />
                ) : (
                  <MoneyWithCurrencyIcon value={DRAW_AMOUNT} />
                ),
              }}
            ></Trans>
          </WrappedButton>
        </Stack>
        <WrappedButton
          isLoading={loading}
          disabled={drawing}
          startIcon={<RocketLaunchRounded></RocketLaunchRounded>}
          onClick={() => clickDraw(true)}
          sx={{
            [theme.breakpoints.down('sm')]: {
              flexGrow: 1,
            },
          }}
        >
          {t('moon-draw::Try For Free')}
        </WrappedButton>
        <WrappedButton
          sx={{
            [theme.breakpoints.down('sm')]: {
              flexBasis: '10%',
            },
          }}
          onClick={() => {
            setEnableTurboMode(!enableTurboMode);
          }}
          variant={enableTurboMode ? 'contained' : 'plain'}
        >
          <Bolt></Bolt>
        </WrappedButton>
      </Stack>
    </Stack>
  );
};

const DrawCarousel = ({ drawRewards }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [wrapperStyle, setWrapperStyle] = useState<React.CSSProperties>({});

  const needleRef = useRef<HTMLSVGElement>(null);

  const startingWidth = useRef(0);
  const [t] = useTranslation();

  const setCarouselEdge = () => {
    const mainWidth = document.querySelector('main')?.offsetWidth;

    setWrapperStyle({
      marginLeft: `-${(mainWidth - startingWidth.current) / 2}px`,
      marginRight: `-${(mainWidth - startingWidth.current) / 2}px`,
    });

    const needleDimension = needleRef.current.getBoundingClientRect();
    const needleMiddlePoint = needleDimension.left + needleDimension.width / 2;

    const rewardItems = wrapperRef.current.querySelectorAll(
      `.moon-draw-item-wrapper`,
    );

    if (!rewardItems) return;

    const rewardItemsArr = Array.from(rewardItems);

    for (let index = 0; index < rewardItemsArr.length; index++) {
      const element = rewardItemsArr[index];
      const elementDimension = element.getBoundingClientRect();

      if (elementDimension.left >= needleMiddlePoint) {
        const targetElement = rewardItemsArr[Math.max(0, index)];
        const targetElementDimensions = targetElement.getBoundingClientRect();
        const targetElementMiddlePoint =
          (targetElementDimensions.left + targetElementDimensions.right) / 2 -
          (mainWidth - startingWidth.current) / 2;

        const firstChild = wrapperRef.current.children[0] as HTMLDivElement;
        firstChild.style.marginLeft = `${
          needleMiddlePoint - targetElementMiddlePoint
        }px`;
        break;
      }
    }
  };
  useIsomorphicLayoutEffect(() => {
    if (isServer) return;

    startingWidth.current = wrapperRef.current.offsetWidth;

    setCarouselEdge();
    window.addEventListener('resize', setCarouselEdge);
    return () => window.removeEventListener('resize', setCarouselEdge);
  }, []);
  return (
    <Stack gap={1} position={'relative'}>
      <Box
        ref={needleRef}
        sx={{
          position: 'absolute',
          left: 'calc(50%)',
          transform: 'translateX(-50%)',
          top: '-3em',
        }}
      >
        <ArrowDropDown
          sx={{
            color: 'white',
            fontSize: '3em',
          }}
        />
      </Box>
      <DrawWrapper ref={wrapperRef} style={wrapperStyle}>
        {Array.from({ length: 5 }).map((_, index) => {
          return (
            <DrawGroupWrapper key={index}>
              {drawRewards.map((draw) => {
                return (
                  <GradientBox
                    key={draw.chance}
                    className="moon-draw-item-wrapper"
                  >
                    <DrawItemWrapper
                      sx={{
                        color: (theme) =>
                          draw.amount >= 199
                            ? theme.palette.primary.main
                            : undefined,
                      }}
                    >
                      <Box
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          opacity: 0.5,
                          zIndex: 0,
                          // borderRadius: theme.shape.borderRadius,
                          overflow: 'hidden',
                          display: 'grid',
                          placeContent: 'center',
                        }}
                      >
                        <Image
                          src={
                            draw.amount === 999
                              ? prizeIImage
                              : draw.amount === 499
                                ? prizeIIImage
                                : draw.amount === 199
                                  ? prizeIIIImage
                                  : draw.amount >= 1.8
                                    ? prizeVoncherImage
                                    : prizeVoncher2Image
                          }
                          alt="prize"
                          style={{
                            aspectRatio: draw.amount >= 199 ? '1/1' : '2.41/1',
                            height: 'auto',
                            transform:
                              draw.amount >= 199 ? undefined : 'rotate(-15deg)',
                            width: draw.amount >= 199 ? undefined : '80%',
                            margin: 'auto',
                          }}
                        ></Image>
                      </Box>
                      <Box
                        sx={{
                          position: 'relative',
                          zIndex: 1,
                        }}
                      >
                        {formatMoneyByCurrency(draw.amount, {
                          withCurrencySymbol: true,
                          decimal: 2,
                        })}
                      </Box>
                    </DrawItemWrapper>
                  </GradientBox>
                );
              })}
            </DrawGroupWrapper>
          );
        })}
      </DrawWrapper>
      <DrawBtn wrapperRef={wrapperRef} drawRewards={drawRewards} />
    </Stack>
  );
};

export default DrawCarousel;
